// src/main.js (or your equivalent entry file)
import { createApp } from 'vue';
import App from './App.vue';
// No need to import bus here unless you need to emit events globally outside components

// Note: Vue.config.productionTip = false; is default in Vue 3 development builds
// and has no effect in production builds, so it can be removed.

const app = createApp(App);

// If you need global properties (use sparingly)
// app.config.globalProperties.$axios = axiosClient;

app.mount('#dynamic_profile_nav');

// Remove window.vue = ... - It's not standard practice in Vue 3
